module.exports = __webpack_public_path__ + "static/media/loader-big.a770b679.gif";